import { useEffect, useState } from "react";

/**
 * useIsTouch — returns true on coarse-pointer (touch-primary) devices and
 * keeps the value live across orientation changes / docked-keyboard hot-plug.
 */
export function useIsTouch() {
  const [isTouch, setIsTouch] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(pointer: coarse)").matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia("(pointer: coarse)");
    const handler = (e) => setIsTouch(e.matches);
    // Safari < 14 uses addListener.
    if (mql.addEventListener) mql.addEventListener("change", handler);
    else mql.addListener(handler);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", handler);
      else mql.removeListener(handler);
    };
  }, []);

  return isTouch;
}

/**
 * useIsNarrow — true when the viewport is narrower than the given breakpoint.
 * Used to flip the HUD into a more compact mobile layout.
 */
export function useIsNarrow(breakpoint = 900) {
  const [isNarrow, setIsNarrow] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < breakpoint;
  });
  useEffect(() => {
    if (typeof window === "undefined") return;
    const onResize = () => setIsNarrow(window.innerWidth < breakpoint);
    window.addEventListener("resize", onResize);
    onResize();
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return isNarrow;
}
